import { cloneElement } from 'react'
import classnames from 'classnames'
import { ROLES } from '../index'
import { format, parseISO } from '../../../utils/date-service'

export default function DateWrapper({ date, role, children }) {
  return (
    <div className={classnames('timeWrapper', { sent: role === ROLES.sender })}>
      <span>{format(parseISO(date, { withTime: true }), 'MMM dd hh:mm aa')}</span>

      {cloneElement(children, { role })}

      <style jsx>{`
        .timeWrapper {
          width: 100%;
          margin: 0.8rem 0 0 auto;

          > span {
            color: var(--secondary-text-color);
            font-size: 1.4rem;
            font-weight: 700;
          }

          &.sent {
            text-align: end;
          }
        }

        :global(.timeWrapper + .timeWrapper) {
          margin: 0.8rem 0 0 auto;
        }

        @media (max-width: 1024px) {
          .wrapper {
            margin: 0.6rem 0 0.6rem auto;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  )
}
